import { Space } from 'antd';
import SwitchDate from './SwitchDate';
import { DatePicker } from '@maxtropy/components';
import { useMemo, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { getDefaultActiveKey, getDefaultRangeByActiveKey, onChangePicker, TimePickerUtil } from './util';
import { ModalType, RangeValue, TimeActive } from './type';

interface DMYDateSwitchProps {
  onActiveKeyChange?: (activeKey: TimeActive) => void;
  onRangeDateChange?: (rangeDate: RangeValue) => void;
  switchOption?: ModalType;
}
const DMYDateSwitch = ({ onActiveKeyChange, onRangeDateChange, switchOption }: DMYDateSwitchProps) => {
  const RangePicker = DatePicker.RangePicker;
  const [activeKey, setActiveKey] = useState<TimeActive>(getDefaultActiveKey()); // 选择的switch时间范围
  const picker = useMemo(() => TimePickerUtil(activeKey), [activeKey]);
  const [rangeDate, setRangeDate] = useState<RangeValue>(getDefaultRangeByActiveKey(activeKey, switchOption));

  const switchChange = (value: TimeActive) => {
    setActiveKey(value);
    const newDate = getDefaultRangeByActiveKey(value, switchOption);
    setRangeDate(newDate);
    onRangeDateChange?.(newDate);
    onActiveKeyChange?.(value);
  };

  //给予父组件初始值
  useEffect(() => {
    onActiveKeyChange?.(activeKey);
    onRangeDateChange?.(rangeDate);
  }, []);
  return (
    <>
      <Space size={8} style={{ marginLeft: 'auto' }}>
        <SwitchDate
          defaultValue={activeKey}
          onChange={value => {
            switchChange(value);
          }}
          options={
            switchOption === ModalType.PipeLoss
              ? [
                  { label: '按日', value: TimeActive.THIS_DAY },
                  // { label: '按周', value: TimeActive.THIS_WEEK },
                  // { label: '按月', value: TimeActive.THIS_MONTH },
                ]
              : [
                  { label: '按日', value: TimeActive.THIS_DAY },
                  { label: '按月', value: TimeActive.THIS_MONTH },
                  { label: '按年', value: TimeActive.THIS_YEAR },
                ]
          }
        />
        <RangePicker
          picker={picker}
          value={rangeDate}
          disabledDate={current => current && current > dayjs().startOf('day')}
          onChange={dates => {
            if (!dates || !dates[0] || !dates[1]) return;
            onChangePicker(dates as RangeValue, activeKey, setRangeDate, onRangeDateChange);
          }}
          allowClear={false}
        />
      </Space>
    </>
  );
};

export default DMYDateSwitch;
